import Vue from 'vue'
import Vuex from 'vuex'
import * as _ from 'lodash'
import { Notification, RootState } from './store-types'
import { user } from './modules/user'
import { userStat } from './modules/user-stat'
import { userMembership } from './modules/user-membership'
import { translation } from './modules/translation'
import { page } from './modules/page'
import { param } from './modules/param'
import { workout } from './modules/workout'
import { workoutExecution } from './modules/workout-execution'
import { programExecution } from './modules/program-execution'
import { healthSection } from './modules/health-section'
import { healthSectionCollection } from './modules/health-section-collection'
import { healthArticle } from './modules/health-article'
import { healthArticleCollection } from './modules/health-article-collection'
import { glossarySection } from './modules/glossary-section'
import { glossarySectionCollection } from './modules/glossary-section-collection'
import { glossaryDefinition } from './modules/glossary-definition'
import { glossaryDefinitionCollection } from './modules/glossary-definition-collection'
import { adviceSection } from './modules/advice-section'
import { adviceSectionCollection } from './modules/advice-section-collection'
import { advice } from './modules/advice'
import { externalContent } from './modules/external-content'
import { adviceCollection } from './modules/advice-collection'
import { externalContentCollection } from './modules/external-content-collection'
import { tagSection } from './modules/tag-section'
import { tagSectionCollection } from './modules/tag-section-collection'
import { tag } from './modules/tag'
import { tagCollection } from './modules/tag-collection'
import { badgeSection } from './modules/badge-section'
import { badgeSectionCollection } from './modules/badge-section-collection'
import { badge } from './modules/badge'
import { badgeCollection } from './modules/badge-collection'
import { workoutCollectionItem } from './modules/workout-collection-item'
import { workoutCollectionList } from './modules/workout-collection-list'
import { userComment } from './modules/user-comment'
import { userCommentCollection } from './modules/user-comment-collection'
import { program } from './modules/program'
import { event } from './modules/event'
import { group } from './modules/group'
import { role } from './modules/role'
import { feedback } from './modules/feedback'
import { feedbackStat } from './modules/feedback-stat'
import { notification } from './modules/notification'
import { complaint } from './modules/complaint'
import { appContent } from '@/store/modules/app-content'
import { userCollection } from './modules/user-collection'
import { pageCollection } from './modules/page-collection'
import { paramCollection } from './modules/param-collection'
import { goalCollection } from './modules/goal-collection'
import { strokeCollection } from './modules/stroke-collection'
import { workoutCollection } from './modules/workout-collection'
import { workoutExecutionCollection } from './modules/workout-execution-collection'
import { programCollection } from './modules/program-collection'
import { programExecutionCollection } from './modules/program-execution-collection'
import { raceExecutionCollection } from './modules/race-execution-collection'
import { eventCollection } from './modules/event-collection'
import { groupCollection } from './modules/group-collection'
import { roleCollection } from './modules/role-collection'
import { rankCollection } from './modules/rank-collection'
import { feedbackCollection } from './modules/feedback-collection'
import { notificationCollection } from './modules/notification-collection'
import { complaintCollection } from './modules/complaint-collection'
import { userStatisticCollection } from './modules/user-statistic-collection'
import { lazyTranslation } from './modules/lazy-translation'
import { stat } from './modules/stat'
import { statUser } from './modules/stat-user'
import { statTotal } from './modules/stat-total'
import { statRankCollection } from './modules/stat-rank-collection'
import { appContentCollection } from './modules/app-content-collection'
import { webhookLogCollection } from './modules/webhook-log-collection'
import { userMainGoalCollection } from './modules/user-main-goal-collection'
import { mainGoalCollection } from './modules/main-goal-collection'
import { filer } from './modules/filer'
import { defaults } from './defaults'
import { premiumPersonalizedPlanCollection } from './modules/premium-personalized-plan-collection'
import { premiumTrialCollection } from './modules/premium-trial-collection'
import { premiumLifetimeCollection } from './modules/premium-lifetime-collection'
import { premiumUserFeedbackCollection } from './modules/premium-user-feedback-collection'
import { club } from './modules/club'
import { clubCollection } from './modules/club-collection'
import { clubAthlete } from './modules/club-athlete'
import { clubAthleteCollection } from './modules/club-athlete-collection'
import { clubProduct } from './modules/club-product'
import { clubProductCollection } from './modules/club-product-collection'
import { clubContent } from './modules/club-content'
import { clubContentCollection } from './modules/club-content-collection'
import { clubEvent } from './modules/club-event'
import { clubEventCollection } from './modules/club-event-collection'

Vue.use(Vuex)

const state: RootState = {
    notifications: []
}

const store = new Vuex.Store({
    state,
    mutations: {
        notify(state: any, payload: Notification) {
            state.notifications.push({
                id: state.notifications.length + 1,
                color: payload.color || 'success',
                message: payload.message
            })
        },
        readNotification(state: any, payload: number) {
            const index = _.findIndex(state.notifications, { id: payload })
            if (index !== -1) {
                state.notifications.splice(index, 1)
            }
        },
    },
    actions: {
        notify(context: any, payload: Notification) {
            context.commit('notify', payload)
        },
        readNotification(context: any, payload: number) {
            context.commit('readNotification', payload)
        },
    },
    getters: {
        notifications: (state: any) => {
            return state.notifications
        }
    },
    modules: {
        user,
        userStat,
        userMembership,
        translation,
        page,
        param,
        workout,
        workoutExecution,
        programExecution,
        healthSection,
        healthArticle,
        glossarySection,
        glossaryDefinition,
        adviceSection,
        advice,
        externalContent,
        tagSection,
        tag,
        badgeSection,
        badge,
        workoutCollectionItem,
        workoutCollectionList,
        userComment,
        program,
        event,
        group,
        role,
        feedback,
        feedbackStat,
        notification,
        complaint,
        appContent,
        userCollection,
        pageCollection,
        paramCollection,
        goalCollection,
        strokeCollection,
        workoutCollection,
        healthSectionCollection,
        healthArticleCollection,
        glossarySectionCollection,
        glossaryDefinitionCollection,
        externalContentCollection,
        adviceSectionCollection,
        adviceCollection,
        tagSectionCollection,
        tagCollection,
        badgeSectionCollection,
        badgeCollection,
        workoutExecutionCollection,
        userCommentCollection,
        programCollection,
        programExecutionCollection,
        raceExecutionCollection,
        eventCollection,
        groupCollection,
        roleCollection,
        rankCollection,
        feedbackCollection,
        notificationCollection,
        complaintCollection,
        userStatisticCollection,
        lazyTranslation,
        stat,
        statUser,
        statTotal,
        statRankCollection,
        appContentCollection,
        webhookLogCollection,
        userMainGoalCollection,
        mainGoalCollection,
        filer,
        defaults,
        premiumPersonalizedPlanCollection,
        premiumTrialCollection,
        premiumLifetimeCollection,
        premiumUserFeedbackCollection,
        club,
        clubCollection,
        clubAthlete,
        clubAthleteCollection,
        clubProduct,
        clubProductCollection,
        clubContent,
        clubContentCollection,
        clubEvent,
        clubEventCollection,
    }
})

export default store

export function useStore() {
    return store
}
